import { defineRouting } from 'next-intl/routing';

// Single source of truth for locale routing — consumed by middleware.ts and
// navigation.ts so they can never drift apart.
export const routing = defineRouting({
  locales: ['pl', 'en', 'ua', 'ru'],
  defaultLocale: 'pl',
  localePrefix: 'as-needed',
  // Suppress next-intl's auto `Link:` alternates header. It uses the raw routing
  // locale ("ua") as the hreflang value — an invalid language code that fails the
  // Lighthouse SEO audit. Our HTML <head> already emits the correct hreflang
  // ("uk" for the /ua route) via Next metadata alternates in layout.tsx; that is
  // the single source of truth.
  alternateLinks: false,
});
